export const LOGIN = "/login";
export const SIGNUP = "/create_user";
export const FORGOT_PASSWORD = "/forgot_password";
export const SEARCH_HIS_CODE = "/search_his_codes";
export const HIS_CODE_DETAIL = "/his_code_detail";
export const GET_DUTIES_RATE_BY_HTS_TEST = "/get_duties_rate_by_hts_test";
export const GET_JSON_BY_HISCODE = "/his_code_detail";
export const GET_DATA_BY_HTSCODE = "/get_duties_rate_by_hts_test";
// export const GET_COUNTRY_BY_STATUS = "/get_static_countries_by_status";
export const GET_CHAPTER_NUMBERS = "/get_chapter_numbers";
export const GET_HTS_BY_CHAPTER = "/get_hts_by_chapter";
export const UPLOAD_HTS_JSON = "/upload_duties_rate_json_test";
export const GET_CHAPTER_NUMBER = "/get_chapter_numbers_full";
export const GET_PRODUCT_BY_HISCODE = "/his_code";
// export const GET_PRODUCT_JSON_BY_COUNTRY = "/his_category";
export const GET_PRODUCT_JSON_BY_COUNTRY = "/his_category_tree";
// export const GET_PRODUCT_JSON_BY_COUNTRY = "/categories_tree/";
export const GET_COUNTRY_BY_STATUS = "/his_countries";
export const GET_SCRAPPED_COUNTRIES = "/scrapped_countries";
// export const GET_SEARCH_PRODUCT = "/search_his_category";
// export const GET_SEARCH_PRODUCT = "/search_his_product_category";
export const GET_SEARCH_PRODUCT = "/search_his_codes";
// export const GET_PRODUCT_TARIFF_DATA = "/tariff";
// export const GET_PRODUCT_TARIFF_DATA = "/tariff_by_country_profile_exception";
export const GET_PRODUCT_TARIFF_DATA = "/tariff_details";
